import React from "react";
import { whatsappLink } from "@/data/constants";

export const WhatsappFloat = () => {
  return (
    <a
      href={whatsappLink()}
      target="_blank"
      rel="noopener noreferrer"
      className="mn-wa-float"
      aria-label="Falar no WhatsApp"
      data-testid="whatsapp-float"
    >
      <i className="fa-brands fa-whatsapp" />
    </a>
  );
};

export default WhatsappFloat;
